import React from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";
import { Checkbox, Col, Form, Row, Tooltip } from "antd";
import classNames from "classnames";
import { getIn } from "formik";
import moment from "moment";

import AppButton from "components/button";

import ListInput from "./listInput";

import styles from "./styles.module.scss";

const CheckboxGroup = Checkbox.Group;

const FormInput = props => {
  const { t } = useTranslation();
  const below768 = useMedia("(max-width: 767.2px)");
  // layout = { horizontal, vertical, inline}
  const { column = 24, items, onChange, layout, style, form = {} } = props;
  const { values, errors, touched } = form;
  const renderItem = item => {
    const {
      key,
      label,
      placeholder,
      name,
      required,
      disabled,
      readOnly,
      config,
      type,
      span = 24,
      options,
      selectKeyLabel,
      selectKeyValue,
      button,
      checkBox,
      render,
      icon,
      onClick,
      style,
      size,
      colon,
      noAllowClear,
      tagRender,
      labelRender,
    } = item;

    const value = getIn(values, key);
    const error = getIn(errors, key);
    const touch = getIn(touched, key);
    let showError = false;
    if (type === "select" && value) {
      showError = true && error;
    } else {
      showError = error && touch;
    }

    return (
      <Col span={span} key={`${key}-${label}`}>
        {labelRender && labelRender()}
        <Form.Item
          colon={colon}
          label={
            !labelRender ? (
              required ? (
                <div className={styles.required} style={config?.styleLabel}>
                  {t(label)}
                </div>
              ) : label ? (
                readOnly ? null : (
                  <div style={config?.styleLabel}>{t(label)}</div>
                )
              ) : null
            ) : null
          }
          style={style ? style : null}
          span={span}
          validateStatus={showError && "error"}
          help={showError && t(error)}
        >
          {render ? (
            <React.Fragment>{render}</React.Fragment>
          ) : (
            <div
              className={`${
                !readOnly ? "row-all-center " : ""
              } justify-content-start`}
            >
              {disabled && (
                <div
                  className={classNames({
                    [styles.disabled]: !disabled,
                    [styles.clickable]: !!onClick,
                    [styles.flexBox1]: true,
                  })}
                  onClick={() => onClick && onClick()}
                >
                  {type === "checkbox-group" ? (
                    <CheckboxGroup
                      value={value}
                      options={options}
                      name={key}
                      disabled={true}
                    />
                  ) : config?.format && value && value !== "" ? (
                    moment(value).format(config.format)
                  ) : typeof value === "string" ||
                    typeof value === "number" ||
                    typeof value === "boolean" ||
                    typeof value === "undefined" ? (
                    <div
                      className={classNames({
                        [styles.clickable]: type !== "editor" && disabled,
                        [styles.flexBox1]: true,
                      })}
                    >
                      {ListInput.getInput(
                        type,
                        {
                          label,
                          value,
                          options,
                          selectKeyValue,
                          selectKeyLabel,
                          disabled,
                          noAllowClear,
                          readOnly,
                          config,
                          icon,
                          size,
                          placeholder: t(placeholder) ?? t(label),
                        },
                        {
                          onChange: val => {
                            onChange && onChange(name || key, val);
                          },
                        }
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
              {readOnly && (
                <Row
                  className={styles.readOnly}
                  style={{
                    display: "flex",
                    // justifyContent: "center",
                    alignContent: "center",
                    alignItems: config?.isLeft
                      ? "flex-start"
                      : config?.multipleLine
                      ? "flex-start"
                      : "center",
                    margin: below768 ? "6px 0" : 0,
                  }}
                >
                  <Col span={below768 ? 24 : 10} style={{ display: "flex" }}>
                    <div
                      style={{
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: config?.multipleLine
                          ? "flex-start"
                          : "center",
                        marginLeft: icon ? "10px" : 0,
                      }}
                    >
                      {icon && (
                        <>
                          <div
                            className={styles.readOnlyIcon}
                            style={{
                              backgroundColor: "#F4F5F7",
                              borderRadius: "4px",
                              height: "26px",
                              width: "26px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {icon}
                          </div>
                        </>
                      )}
                      <div style={{ marginLeft: "10px", color: "#4D5761" }}>
                        {label}
                      </div>
                    </div>
                  </Col>
                  <Col
                    span={below768 ? 24 : 14}
                    style={
                      config?.isRight
                        ? {
                            display: "flex",
                            justifyContent: "right",
                            paddingRight: "10px",
                          }
                        : config?.isLeft
                        ? {
                            display: "flex",
                            justifyContent: "left",
                            paddingRight: "10px",
                          }
                        : { display: "flex" }
                    }
                  >
                    <div
                      style={{
                        color: "#111927",
                        fontWeight: 500,
                        marginLeft: below768 ? "50px" : "",
                        overflow: config?.multipleLine ? "none" : "hidden",
                        textOverflow: config?.multipleLine
                          ? "none"
                          : "ellipsis",
                        whiteSpace:
                          config?.isLeft || config?.multipleLine
                            ? ""
                            : "nowrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {config?.isTooltip ? (
                        <Tooltip title={value}>{value}</Tooltip>
                      ) : value !== null &&
                        value !== undefined &&
                        value.toString().includes("\n") ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: value.replaceAll("\n", "<br/>"),
                          }}
                        />
                      ) : (
                        <>{value}</>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
              <div
                className={classNames({
                  [styles.disabled]: disabled,
                  [styles.flexBox1]: true,
                })}
              >
                {ListInput.getInput(
                  type,
                  {
                    label,
                    value,
                    options,
                    selectKeyValue,
                    selectKeyLabel,
                    disabled,
                    noAllowClear,
                    readOnly,
                    config,
                    icon,
                    size,
                    placeholder: t(placeholder) ?? t(label),
                    tagRender,
                  },
                  {
                    onChange: val => {
                      onChange && onChange(key || key, val);
                    },
                  }
                )}
              </div>

              {button && (
                <AppButton
                  className={classNames("ml-2", button.className ?? "")}
                  onClick={button.onClick && button.onClick}
                  disabled={button.disabled}
                  loading={button.loading}
                  label={t(button.label)}
                  color={button.color || "grey"}
                  size="small"
                />
              )}
              {checkBox && (
                <Checkbox
                  onChange={event => {
                    const value = event.target.checked;
                    checkBox.onChange && checkBox.onChange(value);
                  }}
                  checked={checkBox.value}
                  className={classNames(
                    "ml-2",
                    checkBox.className ?? "",
                    "text-nowrap"
                  )}
                >
                  {t(checkBox.label)}
                </Checkbox>
              )}
            </div>
          )}
        </Form.Item>
      </Col>
    );
  };
  return (
    <Form layout={layout} className={styles.formInput} style={style}>
      <Row gutter={column}>
        {items && items.filter(input => !input.hidden).map(renderItem)}
      </Row>
    </Form>
  );
};

export default FormInput;
